import { useTranslation } from "@repo/i18n";
import { BookingJourney } from "../booking/BookingJourney";
import type { BookingFlowContext } from "../booking/context";

export type { BookingFlowContext } from "../booking/context";
export { toBookingFlowContext } from "../booking/context";

/**
 * The mount seam for the booking journey (tasks/diner-booking-ui.md): the shell resolved embedding,
 * isolation, resize, i18n, channel plumbing, CSP/CORS and the fail-safe frames; this renders the
 * date/party/slot/hold/details journey inside it, reading everything it needs from `context`. The
 * wrapper keeps the channel-attribution data-attributes the shell contract exposes.
 */
export function BookingFlowOutlet({ context }: { context: BookingFlowContext }) {
  const { t } = useTranslation();
  return (
    <section
      aria-label={t("widget.book")}
      data-testid="booking-flow-outlet"
      data-channel={context.channel}
      data-booking-channel={context.bookingChannel}
      data-venue={context.venueSlug}
      data-preview={context.preview ? "" : undefined}
    >
      {context.preview ? (
        <output className="rsv-notice" data-testid="preview-banner">
          {t("widget.preview.banner")}
        </output>
      ) : null}
      <BookingJourney context={context} />
    </section>
  );
}
